import React, { useState } from 'react';

import Carousel from 'react-bootstrap/Carousel';

import './academic.css';



const Academic = () => {

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <div name='academic' className='Academic reveal'  >
      <div className='container'>
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button className="nav-link" id="nav-service-tab" data-bs-toggle="tab" data-bs-target="#nav-service" type="button" role="tab" aria-controls="nav-service" aria-selected="true">Services</button>
            <button className="nav-link" id="nav-programming-tab" data-bs-toggle="tab" data-bs-target="#nav-programming" type="button" role="tab" aria-controls="nav-programming" aria-selected="false">Programming</button>
            <button className="nav-link" id="nav-certificate-tab" data-bs-toggle="tab" data-bs-target="#nav-certificate" type="button" role="tab" aria-controls="nav-certificate" aria-selected="false">Certificate</button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">


          <div className="tab-pane fade show active" id="nav-service" role="tabpanel" aria-labelledby="nav-service-tab">

            <div className='container-card-academic'>

              <div className='card'>
                <div className='imgbox'>
                  <img src={require('../../photos/images.png')} alt="iic_image" />
                </div>
                <div className='content '>
                  <h1>UI/UX</h1>
                  <h1>Design</h1>
                  <h2>Figma</h2>

               



                </div>

              </div>


              <div className='card'>
                <div className='imgbox'>
                  <img src={require('../../../PortfolioContainer/photos/full-stack-programmer-4296027-3563362(2).webp')} alt="mac_image"/>
                </div>
                <div className='content'>
                  <h1>Frontend</h1> 
                  <h2>HTML</h2>
                  <h2>CSS</h2>
                  <h2>Javascript</h2>

                </div>

              </div>



              <div className='card'>
                <div className='imgbox'>
                  <img src={require('../../photos/backend-roadmap-2021-cover-icon-1-original.webp')} alt="dtea_image"/>
                </div>
                <div className='content'>
                  <h1>Backend</h1>
                  <h2>NodeJs</h2>
                 </div>











              </div>



              <div className='card'>
                <div className='imgbox'>
                  <img src={require('../../../PortfolioContainer/photos/Database_Hero – 1.webp')} alt="ga_image"/>
                </div>
                <div className='content'>
                  <h1>Database</h1>
                  <h2>MongoDb</h2>
                
                </div>

              </div>
            </div>



          </div>





          <div className="tab-pane fade" id="nav-programming" role="tabpanel" aria-labelledby="nav-programming-tab">

            <div className='skill-bar'>
              <div className='bar'>
                <div className='info'>
                  <span>HTML</span>
                </div>
                <div className='progress-line html'><span></span></div>
              </div>

              <div className='bar'>
                <div className='info'>
                  <span>CSS</span>
                </div>
                <div className='progress-line css'><span></span></div>
              </div>

              <div className='bar'>
                <div className='info'>
                  <span>Javascript</span>
                </div>
                <div className='progress-line javascript'><span></span></div>
              </div>

              <div className='bar'>
                <div className='info'>
                  <span>ReactJs</span>
                </div>
                <div className='progress-line reactjs'><span></span></div>
              </div>


              <div className='bar'>
                <div className='info'>
                  <span>MongoDb</span>
                </div>
                <div className='progress-line mongodb'><span></span></div>
              </div>

              <div className='bar'>
                <div className='info'>
                  <span>NodeJs</span>
                </div>
                <div className='progress-line nodejs'><span></span></div>
              </div>

              <div className='bar'>
                <div className='info'>
                  <span>Python</span>
                </div>
                <div className='progress-line python'><span></span></div>
              </div>

              




            </div>
          </div>
          <div className="tab-pane fade" id="nav-certificate" role="tabpanel" aria-labelledby="nav-certificate-tab">

            <div className='Certificate'>
              <div className='container'>
                <Carousel activeIndex={index} onSelect={handleSelect}>
                  <Carousel.Item>
                    <img
                      className="d-block"
                      src={require('../../photos/Certificate degisnare technology_page-0001.jpg')}
                      alt="First slide"
                    />
                 
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block "
                      src={require('../../photos/ashish ui-ux design certificate_page-0001.png')}
                      alt="Second slide"
                    />
 
                  </Carousel.Item>
                  <Carousel.Item>
                    <img
                      className="d-block"
                      src={require('../../photos/Ashish Kumar_AI_AWARE_CERTIFICATE.png')}
                      alt="Third slide"
                    />
 
                  </Carousel.Item>
                </Carousel>
              </div>




            </div>
          </div>

        </div>
      </div>
    </div>
  )


}

export default Academic;